// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".youtube-player{position:relative;padding-bottom:56.25%;height:0}.youtube-player iframe{border:none;position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
